import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { type DashboardFilters } from "./useLiveDashboardFilters";

export const useLiveAdReport = (filters: DashboardFilters) =>
  useQuery({
    queryKey: ["live_ad_report", filters],
    queryFn: async () => await apiClient.getLiveAdReportData({ queries: filters }),
  });
